<div class="flex flex-col flex-1 gap-2">
  <dx-form
    #formCodiceFiscaleHelper
    [formData]="codiceFiscaleHelperData"
    labelLocation="top"
    [showColonAfterLabel]="false"
    (onFieldDataChanged)="onFieldDataChanged()"
  >
    <dxi-item
      dataField="nome"
      [label]="{
        text: 'Nome' | transloco
      }"
      editorType="dxTextBox"
      [editorOptions]="{
        valueChangeEvent: 'keyup'
      }"
    >
    </dxi-item>

    <dxi-item
      dataField="cognome"
      [label]="{
        text: 'Cognome' | transloco
      }"
      editorType="dxTextBox"
      [editorOptions]="{
        valueChangeEvent: 'keyup'
      }"
    >
    </dxi-item>

    <dxi-item
      dataField="sesso"
      [label]="{
        text: 'Sesso' | transloco
      }"
      editorType="dxSelectBox"
      [editorOptions]="{
        displayExpr: 'display',
        valueExpr: 'value',
        dataSource: [
          { value: 'male', display: 'Maschile' | transloco },
          { value: 'female', display: 'Femminile' | transloco }
        ]
      }"
    >
    </dxi-item>

    <dxi-item
      dataField="dataDiNascita"
      [label]="{
        text: 'Data di nascita' | transloco
      }"
      editorType="dxDateBox"
      [editorOptions]="{
        max: now
      }"
    >
    </dxi-item>

    <dxi-item
      dataField="codiceCatastale"
      [label]="{
        text: 'Comune di nascita' | transloco
      }"
      editorType="dxSelectBox"
      [editorOptions]="{
        dataSource: codiceFiscaleComuniDataSource,
        searchEnabled: true,
        valueExpr: 'codiceCatastale',
        displayExpr: 'comune'
      }"
    >
    </dxi-item>
  </dx-form>
  @if (!hideCancelConfirmButtons) {
    <div class="flex flex-row items-center justify-end gap-2">
      <snt-button
        (onClick)="onCancel()"
        [title]="'Annulla' | transloco"
      ></snt-button>
      <snt-button
        (onClick)="onConfirm()"
        [title]="'Conferma' | transloco"
        type="primary"
      ></snt-button>
    </div>
  }
</div>
